import Vue from 'vue'
import ElementUI from 'element-ui';
import App from './App.vue'
import router from './router'
import store from './store'
import api from './api/install'
import vueSwiper from 'vue-awesome-swiper'

import 'element-ui/lib/theme-chalk/index.css';
import 'swiper/dist/css/swiper.css'
import '@/assets/css/base.scss'

Vue.use(vueSwiper)
Vue.use(api)
Vue.use(ElementUI)

Vue.config.productionTip = false

router.afterEach(route => {
  if (route.meta.title) {
    document.title = route.meta.title
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
